import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import type PerimetreIdee from '../../../../../constants/simulation/perimetreIdee';
import type { ImputationIdee } from '../../../../../interfaces/simulation/ideeImportable';
import {
	getSegmentsImputation,
	SEGMENTS_IMPUTATION,
} from '../../../../../utils/simulation/perimetreIdee';

interface ImportIdeeImputationProps {
	imputation: ImputationIdee;
	perimetre: PerimetreIdee;
}

// Segments d'imputation que le cran actif ne garantit pas. Section en colonne
// fixe a gauche (alignement des familles d'une idee a l'autre), famille et
// sous-famille accolees, article seul sur la ligne suivante
const ImportIdeeImputation = ({
	imputation,
	perimetre,
}: ImportIdeeImputationProps) => {
	const segments = getSegmentsImputation(perimetre);
	if (segments.length === 0) return null;

	return (
		<div
			className={`importIdeeImputation importIdeeImputation${segments.length}`}
			data-testid="importIdeeImputation"
		>
			{segments.map((segment) => {
				const { absent, icone, intitule } = SEGMENTS_IMPUTATION[segment];
				const valeur = imputation[segment];
				return (
					<span
						className={`importIdeeSegment importIdeeSegment-${segment}${valeur ? '' : ' importIdeeSegmentAbsent'}`}
						data-testid={`importIdeeSegment-${segment}`}
						key={segment}
						// Intitule et valeur complete au survol, le libelle pouvant
						// etre tronque
						title={`${intitule} : ${valeur ?? absent}`}
					>
						<Icon iconSet="Lucide" name={icone} size={14} />
						<span className="importIdeeSegmentTexte">{valeur ?? absent}</span>
					</span>
				);
			})}
		</div>
	);
};

export default ImportIdeeImputation;
